export const defaultChatBotSettings = {
  title: 'BotCircuits',
  // No default subtitle: the header falls back to the agent's own name rather
  // than carrying a promotional byline.
  subTitle: '',
  welcomeMessage: 'How can I help you today?',
  inputPlaceHolder: 'Write a message...',
  logo: null,
  tips: [],
};
